/* eslint-disable react-hooks/exhaustive-deps */
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Form, Input, Tooltip, Spin } from 'antd';
import IconBack from '../../assets/Images/icons/icon-back';
import DCDPOService from '../../services/DCDPO.service';
import useNotify from '../../context/Notification/useNotify';
import ModalDiscardChanges from '../../components/Shared/modal/discardChanges';
import { useBlocker } from '../../util/usePrompt';
import { ROUTER } from '../../constants/router';
import EditorPrivacy from '../../components/Shared/forms/EditorPrivacy';

const DCDPOForm = () => {
    const { t } = useTranslation();
    let navigate = useNavigate();
    const notify = useNotify();
    const { mode } = useParams();

    const [form] = Form.useForm();
    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [backAction, setBackAction] = useState(false);
    const [loadingForm, setLoadingForm] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [respondData, setRespondData] = useState();
    // {
    //     nameDPOTh:'”22222222”',
    //     nameDPOEn:'”22222222”',
    //     addressTh:'”22222222”',
    //     addressEn:'”22222222”',
    //     staffNameDPOTh:'”22222222”',
    //     staffNameDPOEn:'”22222222”',
    // }

    const handelOkChange = async () => {
        await setChange(false);
        await setOpenChange(false);
        // await form.resetFields();
        navigate(nextLocation.location.pathname + nextLocation.location.search);
    };

    useBlocker((nextLocation) => onChangePage(nextLocation), change);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setNextLocation(nextLocation);
    };

    useEffect(() => {
        if (mode === 'edit') {
            getDCDPO();
        }
    }, []);

    const getDCDPO = async () => {
        setLoadingForm(true);
        try {
            const { data } = await DCDPOService.getDCDPO();
            const item = data?.resultData;
            setRespondData(item);
            if (item) {
                form.setFieldsValue({
                    nameDPOTh: item?.nameDPOTh,
                    nameDPOEn: item?.nameDPOEn,
                    addressTh: item?.addressTh,
                    addressEn: item?.addressEn,
                    staffNameDPOTh: item?.staffNameDPOTh,
                    staffNameDPOEn: item?.staffNameDPOEn,
                });
            }
            setLoadingForm(false);
        } catch (error) {
            console.log(error);
        }
    };

    const onFinish = async (value) => {
        setLoadingForm(true);
        if (mode === 'create') {
            console.log('create ', value);
            try {
                const { data } = await DCDPOService.createDCDPO({
                    ...value,
                });
                if (data?.resultMsg === 'FAILURE') {
                    setChange(false);
                    setOpenChange(false);
                    setLoadingForm(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('common.FailedSaveData'),
                    });
                } else {
                    notify({
                        title: t('common.Success'),
                        description: t('common.SaveData'),
                    });
                    setChange(false);
                    setOpenChange(false);
                    setBackAction(true);
                    setLoadingForm(false);
                    navigate(ROUTER.CONFIGURATION.DC_DPO);
                }
            } catch (error) {
                setChange(false);
                setOpenChange(false);
                setLoadingForm(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedSaveData'),
                });
            }
        } else {
            console.log('edit ', value);
            try {
                const { data } = await DCDPOService.editDCDPO({
                    id: respondData?.id,
                    ...value,
                });
                if (data?.resultMsg === 'FAILURE') {
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('common.FailedSaveData'),
                    });
                    setLoadingForm(false);
                } else {
                    notify({
                        title: t('common.Success'),
                        description: t('common.SaveData'),
                    });
                    setLoadingForm(false);
                    setOpenChange(false);
                    setChange(false);
                    setBackAction(true);
                    navigate(ROUTER.CONFIGURATION.DC_DPO);
                }
            } catch (error) {
                console.log(error);
                setLoadingForm(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedSaveData'),
                });
            }
        }
    };

    return (
        <div>
            <div className="title flex">
                <div
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        setBackAction(true);
                        navigate(ROUTER.CONFIGURATION.DC_DPO);
                    }}
                >
                    <IconBack />
                </div>
                {mode === 'create' ? (
                    <>{t('dcdpo.add')}</>
                ) : (
                    <>{t('dcdpo.edit')} </>
                )}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('common.Configuration')} / {t('common.DC&DPO')} /
                </span>
                <span>
                    {mode === 'create' ? (
                        <>{t('dcdpo.add')}</>
                    ) : (
                        <>{t('dcdpo.edit')} </>
                    )}
                </span>
            </div>
            <div className="bg-white rounded-xl px-14 py-8 my-4 col-span-2">
                <Spin spinning={loadingForm}>
                    <Form
                        scrollToFirstError={{
                            behavior: 'smooth',
                            block: 'center',
                        }}
                        onFinish={onFinish}
                        form={form}
                        onFieldsChange={(_, allFields) => {
                            if (allFields.length > 0 && !backAction) {
                                setChange(true);
                            }
                        }}
                        className="w-full space-y-4"
                        layout="vertical"
                    >
                        <div
                            className="pb-2"
                            style={{ borderBottom: '3px solid #F4F6FC' }}
                        >
                            <div className="flex space-x-2 items-center justify-between">
                                <div className="grid grid-cols-1">
                                    <div className="text-xl font-[600] text-[#7B67FB]">
                                        {mode === 'create' ? (
                                            <>{t('dcdpo.add')}</>
                                        ) : (
                                            <>{t('dcdpo.edit')} </>
                                        )}
                                    </div>
                                </div>
                                <div className="flex space-x-2">
                                    <Button
                                        type="default"
                                        style={{
                                            width: '120px',
                                            padding: '0px 30px',
                                            color: '#7B67FB',
                                            borderColor: '#7B67FB',
                                        }}
                                        onClick={() => {
                                            setBackAction(true);
                                            navigate(
                                                ROUTER.CONFIGURATION.DC_DPO
                                            );
                                        }}
                                        size="large"
                                    >
                                        {t('common.Cancel')}
                                    </Button>
                                    <Button
                                        size="large"
                                        type="primary"
                                        htmlType="submit"
                                        style={{
                                            width: '120px',
                                        }}
                                    >
                                        {t('common.Save')}
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="pt-2">
                            <div className="flex flex-col my-4 ">
                                <div className="grid grid-cols-12">
                                    <div className="col-span-7 space-y-4">
                                        {/* Name DPO */}
                                        <div
                                            style={{
                                                borderBottom:
                                                    '1px dashed #DBDBDB',
                                            }}
                                        >
                                            <div className="font-[700] text-xl">
                                                {t('dcdpo.DataController')}
                                            </div>
                                            <li className="pb-2 list-disc">
                                                <span className="font-[600] text-base">
                                                    {t('dcdpo.DataController')}{' '}
                                                    <span className="text-[#F0536F]">
                                                        *
                                                    </span>{' '}
                                                    {'(TH)'}
                                                </span>
                                            </li>
                                            <Form.Item
                                                name="nameDPOTh"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message:
                                                            'This field is required.',
                                                    },
                                                    // {
                                                    //     pattern: new RegExp(
                                                    //         /[\u0E00-\u0E7F 0-9 +(),-.]$/g
                                                    //     ),
                                                    //     message:
                                                    //         'This field must be in Thai.',
                                                    // },
                                                ]}
                                            >
                                                <Input
                                                    size="large"
                                                    placeholder={t(
                                                        'dcdpo.DCReqTH'
                                                    )}
                                                />
                                            </Form.Item>
                                            <li className="pb-2 list-disc">
                                                <span className="font-[600] text-base">
                                                    {t('dcdpo.DataController')}{' '}
                                                    {'(EN)'}
                                                </span>
                                            </li>
                                            <Form.Item
                                                name="nameDPOEn"
                                                rules={[
                                                    {
                                                        pattern: new RegExp(
                                                            /[a-zA-Z 0-9 +/(),-.]$/g
                                                        ),
                                                        message:
                                                            'This field must be in English.',
                                                    },
                                                ]}
                                            >
                                                <Input
                                                    size="large"
                                                    placeholder={t(
                                                        'dcdpo.DCReqEN'
                                                    )}
                                                />
                                            </Form.Item>
                                        </div>

                                        {/* Address */}
                                        <div
                                            style={{
                                                borderBottom:
                                                    '1px solid #DBDBDB',
                                            }}
                                        >
                                            <li className="pb-2 list-disc">
                                                <span className="font-[600] text-base">
                                                    {t('dcdpo.Address')}{' '}
                                                    <span className="text-[#F0536F]">
                                                        *
                                                    </span>{' '}
                                                    {'(TH)'}
                                                </span>
                                            </li>
                                            <Form.Item
                                                name="addressTh"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message:
                                                            'This field is required.',
                                                    },
                                                ]}
                                            >
                                                <EditorPrivacy
                                                    placeholder={t(
                                                        'dcdpo.DCReqTH'
                                                    )}
                                                />
                                            </Form.Item>
                                            <li className="pb-2 list-disc">
                                                <span className="font-[600] text-base">
                                                    {t('dcdpo.Address')}{' '}
                                                    {'(EN)'}
                                                </span>
                                            </li>
                                            <Form.Item name="addressEn">
                                                <EditorPrivacy
                                                    placeholder={t(
                                                        'dcdpo.DCReqEN'
                                                    )}
                                                />
                                            </Form.Item>
                                        </div>

                                        {/* Staff */}
                                        <div>
                                            <div className="flex space-x-2 items-center">
                                                <div className="font-[700] text-xl">
                                                    {t('dcdpo.Contact')}
                                                </div>
                                                <Tooltip
                                                    placement="right"
                                                    overlayStyle={{
                                                        minWidth: '23%',
                                                    }}
                                                    title={
                                                        <>
                                                            <div>
                                                                ระบุรายละเอียดเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล
                                                            </div>
                                                            <div>
                                                                (Data Protection
                                                                Officer: DPO)
                                                            </div>
                                                            <div>
                                                                • ชื่อ:
                                                                [ชื่อ-นามสกุล]{' '}
                                                            </div>
                                                            <div>
                                                                • สถานที่ติดต่อ:
                                                                [ที่อยู่สำนักงานใหญ่
                                                            </div>
                                                            <div>
                                                                สถานที่ทำงานของผู้ควบคุมข้อมูล]{' '}
                                                            </div>
                                                            <div>
                                                                •
                                                                ช่องทางการติดต่อ:
                                                                [โทรศัพท์]
                                                                [อีเมล]
                                                            </div>
                                                        </>
                                                    }
                                                >
                                                    <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple">
                                                        <ExclamationCircleOutlined />
                                                    </a>
                                                </Tooltip>
                                            </div>
                                            <li className="pb-2 list-disc">
                                                <span className="font-[600] text-base">
                                                    {t(
                                                        'dcdpo.DataProtectionOfficer'
                                                    )}{' '}
                                                    <span className="text-[#F0536F]">
                                                        *
                                                    </span>{' '}
                                                    {'(TH)'}
                                                </span>
                                            </li>
                                            <Form.Item
                                                name="staffNameDPOTh"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message:
                                                            'This field is required.',
                                                    },
                                                ]}
                                            >
                                                <EditorPrivacy
                                                    placeholder={t(
                                                        'dcdpo.DCReqTH'
                                                    )}
                                                />
                                            </Form.Item>
                                            <li className="pb-2 list-disc">
                                                <span className="font-[600] text-base">
                                                    {t(
                                                        'dcdpo.DataProtectionOfficer'
                                                    )}{' '}
                                                    {'(EN)'}
                                                </span>
                                            </li>
                                            <Form.Item name="staffNameDPOEn">
                                                <EditorPrivacy
                                                    placeholder={t(
                                                        'dcdpo.DCReqEN'
                                                    )}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                </Spin>
            </div>
            <ModalDiscardChanges
                open={openChange}
                handelOk={handelOkChange}
                handelClose={() => setOpenChange(false)}
            />
        </div>
    );
};

export default DCDPOForm;
